/**
 * While the window is being resized or zoomed, the page marks itself (`data-resizing` on <html>) until it has been
 * still for a moment. Transitions are off meanwhile (global.css) and the card's frame does not glide
 * (components/AppCard.tsx): a colour or a border crossing a breakpoint changes at once instead of easing through
 * odd in-between shades, and nothing jumps behind the pointer.
 */
const QUIET_MS = 180;

export function isResizing(): boolean {
  return typeof document !== 'undefined' && document.documentElement.dataset.resizing !== undefined;
}

export function installResizeCalm(): void {
  if (typeof window === 'undefined') return;
  let timer = 0;
  const mark = (): void => {
    document.documentElement.dataset.resizing = '';
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      delete document.documentElement.dataset.resizing;
    }, QUIET_MS);
  };
  window.addEventListener('resize', mark, { passive: true });
  window.visualViewport?.addEventListener('resize', mark, { passive: true });
}
